import { ApiError, OfChatMediasService, VaultService } from '@api'
import { attach, createEffect, createStore } from 'effector'

import { $creatorId } from '@/models/creators.ts'
import { BACKEND_URL_V2 } from '@/utils/constants.ts'
import { handleError } from '@/utils/error'

export const createStreamSignatureFx = attach({
  name: 'create stream signature',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (mediaId: number, { creatorId }) => ({
    mediaId,
    creatorId: creatorId!,
  }),
  effect: createEffect(VaultService.createSignature),
})

export const createExpirableMediaStreamSignatureFx = attach({
  name: 'create expirable media stream signature',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (
    params: { mediaId: number; userId: number; messageId: number },
    { creatorId },
  ) => ({
    ...params,
    creatorId: creatorId!,
  }),
  effect: createEffect(OfChatMediasService.streamV1),
})

export const getStreamingUrlFx = createEffect({
  name: 'get vault media streaming url',
  handler: async ({
    userId,
    messageId,
    mediaId,
    isExpirable,
  }: {
    isExpirable?: boolean
    mediaId: number
    userId?: number
    messageId?: number
  }) => {
    const result = await (isExpirable && messageId && userId
      ? createExpirableMediaStreamSignatureFx({
          mediaId,
          messageId,
          userId,
        })
      : createStreamSignatureFx(mediaId))

    return `${BACKEND_URL_V2}/creator/vault/stream/${result.signature}`
  },
})

export const $streamingError = createStore<Nullable<ApiError>>(null, {
  name: 'media streaming error',
})
  .on(getStreamingUrlFx.failData, (_, error) => error as ApiError)
  .reset(getStreamingUrlFx)

getStreamingUrlFx.failData.watch((error) => {
  handleError(error, 'Error occurred while fetching media, please try again')
})
